"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.appBaseDevelopmentTreeToGoalTreeEnvelope = appBaseDevelopmentTreeToGoalTreeEnvelope;
const app_base_development_tree_1 = require("./app-base-development-tree");
const goal_tree_1 = require("./goal-tree");
function appBaseDevelopmentTreeToGoalTreeEnvelope(input) {
    const tree = app_base_development_tree_1.AppBaseDevelopmentTreeSchema.parse(input);
    return goal_tree_1.GoalTreeEnvelopeSchema.parse({
        schemaVersion: 1,
        domain: 'app_base',
        interactionMode: 'agent',
        mode: tree.mode,
        target: tree.target,
        root: mapNode(tree.root),
        progress: {
            ready: tree.progress.ready,
            configured: tree.progress.configured,
            defaulted: tree.progress.defaulted,
            missing: tree.progress.missing,
            invalid: tree.progress.invalid,
            blocked: tree.progress.blocking,
            total: tree.progress.total,
        },
        gaps: tree.gaps.map(mapGap),
        nextSteps: tree.nextSteps.map(mapNextStep),
        diff: (0, goal_tree_1.toOptionalGoalTreeJsonValue)(tree.diff),
        recipe: (0, goal_tree_1.toOptionalGoalTreeJsonValue)(tree.recipe),
        verification: {
            status: tree.gaps.some(gap => gap.blocking) ? 'failed' : 'passed',
            checks: [
                {
                    checkId: 'app_base_development_tree.blocking_gaps',
                    label: 'Blocking gaps',
                    status: tree.gaps.some(gap => gap.blocking) ? 'failed' : 'passed',
                    reason: tree.gaps.find(gap => gap.blocking)?.reason,
                },
            ],
        },
        uiHints: {
            allowUserPatches: true,
            defaultExpandedDepth: 2,
            orientation: 'vertical',
            renderer: 'streamlain-disclosure-tree',
        },
        payload: {
            appBaseDevelopmentTree: (0, goal_tree_1.toGoalTreeJsonValue)(tree),
        },
    });
}
function mapNode(node) {
    const detail = (0, goal_tree_1.toGoalTreeJsonValue)({
        source: node.source,
        valueKind: node.valueKind,
        value: node.value,
        defaultValue: node.defaultValue,
        allowedValues: node.allowedValues,
        schemaRef: node.schemaRef,
        overrideReason: node.overrideReason,
        validationErrors: node.validationErrors,
        nextSteps: node.nextSteps,
    });
    return {
        nodeId: node.nodeId,
        kind: node.kind,
        label: node.label,
        status: node.status,
        required: node.required,
        valueSummary: summarizeValue(node.value ?? node.defaultValue),
        detail,
        refs: [],
        actions: node.nextSteps.map(step => ({
            actionId: step.nextStepId,
            kind: step.actionKind,
            label: step.label,
            requiresConfirmation: !!step.requiredConfirmation,
        })),
        children: node.children.map(mapNode),
    };
}
function mapGap(gap) {
    return {
        gapId: gap.gapId,
        nodeId: gap.nodeId,
        severity: gap.severity,
        blocking: gap.blocking,
        reason: gap.reason,
        allowedActions: [...gap.allowedActions],
        detail: {
            requiredValueKind: gap.requiredValueKind ?? null,
            expectedSchemaRef: gap.expectedSchemaRef ?? null,
        },
    };
}
function mapNextStep(step) {
    return {
        nextStepId: step.nextStepId,
        nodeId: step.nodeId,
        actionKind: step.actionKind,
        label: step.label,
        requiredConfirmation: step.requiredConfirmation,
    };
}
function summarizeValue(value) {
    if (typeof value === 'string')
        return value.slice(0, 140);
    if (typeof value === 'number' || typeof value === 'boolean') {
        return String(value);
    }
    if (Array.isArray(value))
        return `${value.length} items`;
    if (value && typeof value === 'object') {
        return `${Object.keys(value).length} fields`;
    }
    return undefined;
}
